import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseMailboxes: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 3C2.5 2.17157 3.17157 1.5 4 1.5H15C15.8284 1.5 16.5 2.17157 16.5 3V5.75H9L8.9983 5.75L4 5.75L4 15H5.75V16.5H4C3.17157 16.5 2.5 15.8284 2.5 15V3ZM4 3V4.25L15 4.25V3H4ZM9 7.5C8.17157 7.5 7.5 8.17157 7.5 9V21C7.5 21.8284 8.17157 22.5 9 22.5H20C20.8284 22.5 21.5 21.8284 21.5 21V9C21.5 8.17157 20.8284 7.5 20 7.5H9ZM9 10.25V9H20V10.25L9 10.25ZM9 11.75V21H20V11.75L9 11.75ZM14.5 15.75C15.1904 15.75 15.75 15.1904 15.75 14.5C15.75 13.8096 15.1904 13.25 14.5 13.25C13.8096 13.25 13.25 13.8096 13.25 14.5C13.25 15.1904 13.8096 15.75 14.5 15.75Z"
        fill={color}
      />
    </svg>
  );
};
